// extracted by mini-css-extract-plugin
export default {"container":"PropMap_container__1dKbz","title":"PropMap_title__HgY4l"};